// extracted by mini-css-extract-plugin
export default {"section":"Section_section__hyRwx","tight":"Section_tight__uTVRk","flush":"Section_flush__VcuJW","alt":"Section_alt__81Lz+","dark":"Section_dark__JEo9X"};